import React from 'react';
export const ResultsSection = () => {
  return <section className="py-16 px-6 md:px-10 bg-cream" data-id="element-247">
      <div className="max-w-4xl mx-auto" data-id="element-248">
        <h2 className="section-title text-center mb-12" data-id="element-249">
          Resultados que ya vemos en mujeres reales
        </h2>
        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-250">
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-251">
            <p className="font-semibold text-navy" data-id="element-252">Menos ansiedad</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-253">
            <p className="font-semibold text-navy" data-id="element-254">Más claridad</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-255">
            <p className="font-semibold text-navy" data-id="element-256">Quincenas que rinden</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-257">
            <p className="font-semibold text-navy" data-id="element-258">
              Ahorros pequeños pero constantes
            </p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-259">
            <p className="font-semibold text-navy" data-id="element-260">$100–$200 extra cada mes</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-261">
            <p className="font-semibold text-navy" data-id="element-262">
              Tranquilidad para ayudar sin quedarse vacía
            </p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-263">
            <p className="font-semibold text-navy" data-id="element-264">Mejor autoestima</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-265">
            <p className="font-semibold text-navy" data-id="element-266">Paz mental</p>
          </div>
          <div className="bg-white p-5 rounded-lg shadow-md" data-id="element-267">
            <p className="font-semibold text-navy" data-id="element-268">
              Sentirse en control por primera vez
            </p>
          </div>
        </div>
        <p className="text-center text-xl font-semibold mb-4" data-id="element-269">
          Esto no es solo dinero. Es tu vida. Tu bienestar. Tu tranquilidad.
        </p>
      </div>
    </section>;
};